import React, { useState } from 'react';
import TimesheetGrid from './timesheet-grid';

export default function TimesheetsPage() {
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <div style={{ padding: '2rem' }}>
      {showSuccess && (
        <div
          style={{
            padding: '1rem',
            marginBottom: '2rem',
            backgroundColor: '#d4edda',
            color: '#155724',
            borderRadius: '4px',
            border: '1px solid #c3e6cb',
          }}
        >
          ✓ Timesheet submitted successfully!
        </div>
      )}

      <TimesheetGrid
        onSuccess={() => {
          setShowSuccess(true);
          setTimeout(() => setShowSuccess(false), 5000);
        }}
        onCancel={() => {}}
      />
    </div>
  );
}
